import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportingRoutingModule } from './reporting.routing';
import { ReportingComponent } from './reporting.component';
import { MatIconModule } from '@angular/material/icon';
import { ReportingListComponent } from './@components/list/list.component';
import { ReportingBuilderComponent } from './@components/builder/builder.component';
import { ReportingBuilderFilterComponent } from './@components/builder/filter/filter.component';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { FieldSelectorComponent } from './@components/builder/field-selector/field-selector.component';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { DataTableComponent } from './@components/builder/data-table/data-table.component';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { ReportingCreateModalComponent } from './@components/modals/create/create.component';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { WidgetsModule } from 'app/shared/components/widgets/widgets.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { VisualizationsComponent } from './@components/builder/visualizations/visualizations.component';
import { MatDividerModule } from '@angular/material/divider';
import { ChartSetupComponent } from './@components/builder/visualizations/chart-setup/chart-setup.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ChartModule } from 'app/shared/components/chart/chart.module';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatSortModule } from '@angular/material/sort';
import { DrillDataVisualizationComponent } from './@components/builder/visualizations/drill-data/drill-data.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { ChartSetupModalComponent } from './@components/builder/visualizations/chart-setup-modal/chart-setup-modal.component';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatBadgeModule } from '@angular/material/badge';
import { TimeSeriesDataTableComponent } from './@components/builder/data-table/time-series/time-series.component';
import { SharedModule } from 'app/shared/shared.module';
import { ColumnSelectorModule } from 'app/shared/components/column-selector/column-selector.module';
import { LinkableRelatedToFieldCell } from 'app/shared/components/editable/data-table-linked-field.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import {
  TSIconModule,
  TSTreeMenuModule,
  TsBreadcrumbModule,
  TsButtonModule,
  TsPageComponent,
  TsPageHeaderModule,
  TsPaginatorModule,
  TsInputComponent,
} from 'tsui';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ListWrapperComponent } from './list-wrapper/list-wrapper.component';
import { HasPermissionPipe } from '@shared/pipes/has-permission.pipe';
import { ReportingBuilderConfigurationComponent } from './@components/builder/configuration/configuration.component';

@NgModule({
  declarations: [
    ReportingComponent,
    ReportingListComponent,
    ReportingBuilderComponent,
    ReportingBuilderFilterComponent,
    DataTableComponent,
    ReportingCreateModalComponent,
    VisualizationsComponent,
    ChartSetupComponent,
    DrillDataVisualizationComponent,
    ChartSetupModalComponent,
    TimeSeriesDataTableComponent,
    ListWrapperComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ReportingRoutingModule,
    WidgetsModule,
    ChartModule,
    PipesModule,
    MatIconModule,
    MatCardModule,
    MatSelectModule,
    MatFormFieldModule,
    MatTabsModule,
    MatButtonModule,
    MatTableModule,
    MatSnackBarModule,
    MatDialogModule,
    MatRadioModule,
    MatSidenavModule,
    MatInputModule,
    MatTooltipModule,
    MatDividerModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    OverlayModule,
    NgApexchartsModule,
    DragDropModule,
    MatProgressSpinnerModule,
    TSTreeMenuModule,
    TsPageComponent,
    PipesModule,
    MatDatepickerModule,
    MatBadgeModule,
    SharedModule,
    ColumnSelectorModule,
    FieldSelectorComponent,
    LinkableRelatedToFieldCell,
    TsPaginatorModule,
    MatProgressBarModule,
    TsPageHeaderModule,
    TsBreadcrumbModule,
    TsButtonModule,
    TSIconModule,
    TsInputComponent,
    HasPermissionPipe,
    ReportingBuilderConfigurationComponent,
  ],
})
export class ReportingModule {}
